import api from '../api';
import {parseZodSchema} from '../models/parseZodSchema';
import {
    desklyConnectSettings,
    type DesklyConnectSettings,
    type DesklyConnectForm,
} from '../models/desklyConnect/desklyConnectFormModel';
import {
    desklyConnectUsageStatistics,
    type DesklyConnectUsageStatistics,
} from '../models/desklyConnect/desklyConnectUsageModel';

export default () => ({
    read(accountId: string): Promise<DesklyConnectSettings> {
        return api
            .get(`/api/admin/deskly-connect/${accountId}`)
            .then(api.handle)
            .catch(api.error)
            .then(raw => parseZodSchema(raw, desklyConnectSettings));
    },

    update(accountId: string, settings: DesklyConnectForm): Promise<DesklyConnectSettings> {
        return api
            .put(`/api/admin/deskly-connect/${accountId}`, settings)
            .then(api.handle)
            .catch(api.error)
            .then(raw => parseZodSchema(raw, desklyConnectSettings));
    },

    readUsageStatistics(accountId: string): Promise<DesklyConnectUsageStatistics> {
        return api
            .get(`/api/admin/statistics/deskly-connect-usage/${accountId}`)
            .then(api.handle)
            .catch(api.error)
            .then(raw => parseZodSchema(raw, desklyConnectUsageStatistics));
    },

    authorizeSensor(
        sensorId: string,
        target?: string
    ): Promise<{success: boolean; message: string}> {
        const queryParams = new URLSearchParams({sensorId});
        if (target) {
            queryParams.append('target', target);
        }

        return api
            .post(`/api/deskly-connect/authorize-sensor?${queryParams.toString()}`, null)
            .then(api.handle)
            .catch(api.error);
    },
});
